import React from "react";
import { Link } from "react-router-dom";

/**
 * LinkifyText — @brukernavn → klikkbar lenke til /profil/@brukernavn.
 * #hashtags vises som vanlig tekst (beslutning 06.10.2026: kun søkbare, ikke klikkbare).
 */
const TOKEN_RE = /(@[a-zA-Z0-9_]{2,30})/g;

export default function LinkifyText({ text, className = "" }) {
  if (!text) return null;
  const parts = text.split(TOKEN_RE);
  return (
    <span className={`whitespace-pre-line ${className}`}>
      {parts.map((part, i) => {
        if (!part) return null;
        if (part.startsWith("@")) {
          const uname = part.slice(1);
          return (
            <Link
              key={i}
              to={`/profil/@${uname}`}
              className="text-[var(--magenta)] hover:underline"
              data-testid={`mention-link-${uname}`}
            >
              {part}
            </Link>
          );
        }
        return <React.Fragment key={i}>{part}</React.Fragment>;
      })}
    </span>
  );
}
